import type { PageDefinition } from '@fias/sdui-types';
import { ComponentRenderer } from './ComponentRenderer';

export interface PageRendererProps {
  page: PageDefinition;
  className?: string;
}

export function PageRenderer({ page, className = '' }: PageRendererProps) {
  return (
    <div className={`sdui-page ${className}`}>
      <div
        className="sdui-page-layout"
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {page.layout.map((component) => (
          <ComponentRenderer key={component.id} component={component} />
        ))}
      </div>
    </div>
  );
}

export default PageRenderer;
